import { Data } from './data'

export abstract class Element {
  id: string
  cssId: string | undefined
  cssClasses: string | undefined

  constructor (data: Data) {
    this.id = data.id
    this.cssId = data.settings._element_id
    this.cssClasses = data.settings.css_classes
  }
}
